import TiersIcon from '@material-ui/icons/BarChart';
import { APP_TYPES, roles } from '../../config/constants';
import TiersList from './components/TiersList';
import TierEdit from './components/TierEdit';
import TierCreate from './components/TierCreate';

const options = {
  appTypes: [APP_TYPES.HUNGARY],
  allowedRoles: [roles.ADMIN, roles.JTI_TEAM],
  subMenuName: 'manage',
  label: 'Tiers',
};

export default {
  create: TierCreate,
  edit: TierEdit,
  list: TiersList,
  icon: TiersIcon,
  name: 'admin/tiers-discounts',
  options,
};
